module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h3', {
    staticClass: "h3"
  }, [_c('a', {
    attrs: {
      "id": "page_ix"
    }
  }), _c('a', {
    attrs: {
      "id": "ack"
    }
  }), _c('strong', [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent1"
  }, [_vm._v("Buddhists say that the secret of Zen lies in just two words: not always so. Much the same can be said of terrorism, and I have many to thank for helping me search for answers.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For their patience with things I have no patience for, thanks to Jennifer Brown, Peggy Strobel, David Skelton, and Charles Norman at Indiana State University.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("For bringing this research the light of print, I thank Ilene Kalish at New York University Press.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("The ideas flowing through this work were shaped by an outstanding group of scholars. Thanks to Pat Lauderdale, Henry Brownstein, Marcus Felson, Ronald Akers, Gregg Barak, Bob Bohm, Victoria Bedford, and Lynn Chancer. Thanks also to veteran terrorism researchers Brent Smith, Kelly Damphousse, Christopher Hewitt, Jeff Ross, Josh Frelich, Adam Silverman, Mark Potok, and Brian Levin.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("I owe a special thanks to Jeff Ferrell and Mike Presdee for their humor when the clouds gathered; and to Ken Tunnell, Fran Hoffmann, Cecile Van de Voorde, and Terry Cox for their kindness when the rains came.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("To Lou Hamm and Marla Sandys, I owe something more than thanks.")]), _vm._v(" "), _c('p', {
    staticClass: "indent"
  }, [_vm._v("Proceeds from this book go to the New Orleans Musicians’ Relief Fund, a non-profit support group founded in response to the devastation of Hurricane Katrina.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2129ca1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/acknowledgments.vue
// module id = 72
// module chunks = 0